import { getOrderStatusRolesList } from 'axios/orderStatusApi';
import useApi from 'hooks/useApi';
import RolesQueryInfo from 'models/api/rolesQueryInfo';
import { createContext, useContext, useState } from 'react';
import { useQuery } from 'react-query';

type OrderStatusRolesContextData = {
    orderStatusRoles: RolesQueryInfo[];
    isFetching: boolean;
};

type OrderStatusRolesProviderProps = React.PropsWithChildren<{}>;

const OrderStatusRolesContext = createContext<OrderStatusRolesContextData>(
    {} as OrderStatusRolesContextData
);

const OrderStatusRolesProvider = ({ children }: OrderStatusRolesProviderProps) => {
    const [orderStatusRoles, setOrderStatusRoles] = useState<RolesQueryInfo[]>([]);

    const api = useApi();

    const { isFetching } = useQuery('orderStatusesRoles', () => getOrderStatusRolesList(api), {
        onSuccess: (data) => {
            setOrderStatusRoles(data.data);
        },
        enabled: !orderStatusRoles.length,
    });

    return (
        <OrderStatusRolesContext.Provider
            value={{
                orderStatusRoles,
                isFetching,
            }}
        >
            {children}
        </OrderStatusRolesContext.Provider>
    );
};

const useOrderStatusRolesState = () => {
    const context = useContext(OrderStatusRolesContext);

    return context;
};

export { OrderStatusRolesProvider, useOrderStatusRolesState };
